import ApiService from './api.service';

class TicketTypeService {
  async list() {
    try {
      const response = await ApiService.get('/ticket-type');
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async create(ticketTypeData) {
    try {
      const response = await ApiService.post('/ticket-type/add', ticketTypeData);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async update(ticketTypeData) {
    try {
      const response = await ApiService.put('/ticket-type/update', ticketTypeData);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async delete(ticketTypeId) {
    try {
      const response = await ApiService.delete('/ticket-type/delete', { id: ticketTypeId });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export default new TicketTypeService(); 